import { firebase } from '../firebase'

export async function loginWithGoogle() {
  const provider = new firebase.auth.GoogleAuthProvider()
  provider.addScope('profile')
  provider.addScope('email')
  firebase.auth().signInWithRedirect(provider)
}
